import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterData'
})
export class FilterDataPipe implements PipeTransform {

  transform(value: any[], field: any, args: any): any {
    return value.filter(m => m[field] === args);
  }

}
